const checkAccessAdministrator = (profile) => {
  return profile?.roles?.some((role) => {
    return role.name === 'Administrateur';
  });
};

const checkAccessLeader = (profile) => {
  return profile?.roles?.some((role) => {
    return role.name === 'Administrateur' || role.name === 'Dirigeant';
  });
};

const checkAccessResponsible = (profile) => {
  return profile?.roles?.some((role) => {
    return (
      role.name === 'Administrateur' ||
      role.name === 'Dirigeant' ||
      role.name === 'Responsable SCO' ||
      role.name === 'Responsable SLO' ||
      role.name === 'Responsable SAV' ||
      role.name === 'Responsable Marketing'
    );
  });
};

const checkAccessUser = (profile) => {
  return profile?.roles?.some((role) => {
    return (
      role.name === 'Administrateur' ||
      role.name === 'Dirigeant' ||
      role.name === 'Responsable SCO' ||
      role.name === 'Responsable SLO' ||
      role.name === 'Responsable SAV' ||
      role.name === 'Responsable Marketing' ||
      role.name === 'Operateur SCO' ||
      role.name === 'Operateur SLO' ||
      role.name === 'Operateur SAV' ||
      role.name === 'Operateur Achat' ||
      role.name === 'Operateur Image' ||
      role.name === 'Operateur Finance' ||
      role.name === 'Operateur Marketing'
    );
  });
};

const checkRoleFi = (profile) => {
  return profile?.roles?.some((role) => {
    return (
      role.name === 'Responsable Finance' || role.name === 'Operateur Finance'
    );
  });
};

const checkRoleSav = (profile) => {
  return profile?.roles?.some((role) => {
    return role.name === 'Responsable SAV' || role.name === 'Operateur SAV';
  });
};

const checkRoleSco = (profile) => {
  return profile?.roles?.some((role) => {
    return role.name === 'Responsable SCO' || role.name === 'Operateur SCO';
  });
};

const checkRoleSlo = (profile) => {
  return profile?.roles?.some((role) => {
    return role.name === 'Responsable SLO' || role.name === 'Operateur SLO';
  });
};

const checkRoleSc = (profile) => {
  return profile?.roles?.some((role) => {
    return (
      role.name === 'Responsable SCO' ||
      role.name === 'Responsable SLO' ||
      role.name === 'Responsable SAV' ||
      role.name === 'Operateur SCO' ||
      role.name === 'Operateur SLO' ||
      role.name === 'Operateur SAV'
    );
  });
};

export {
  checkAccessAdministrator,
  checkAccessLeader,
  checkAccessResponsible,
  checkAccessUser,
  checkRoleFi,
  checkRoleSav,
  checkRoleSc,
  checkRoleSco,
  checkRoleSlo,
};
